module.exports = __webpack_public_path__ + "img/nauman-pro.fa6cd400.jpg";